import { Entity } from '@api/api/entity-schema';
import { KgInsightThemeType } from '@api/api/kg-insights';
import { SnakeMeta } from '@api/api/timeseries-schema';
import { IndicatorListItem } from '@chart';
import { AssetLogoContainer } from '@terminal/components/asset-logo-container/AssetLogoContainer';
import React from 'react';

import {
  EntityWithIndicator,
  Item,
  isEntityItem,
  isThemeItem,
  TitleItem,
} from '../../utils';
import { ListEntityItem } from '../list-entity-item/ListEntityItem';
import { ListThemeItem } from '../list-theme-item/ListThemeItem';
import { ListTitleItem } from '../list-title-item/ListTitleItem';

export interface ListItemProps {
  item: Item;
  activeEntity?: Entity;
  isFocused: boolean;
  setFocusedText?: React.Dispatch<React.SetStateAction<string | undefined>>;
  searchQuery: string;
  variant?: 'default' | 'secondary';
  companyCountTypes?: KgInsightThemeType[];
}

export const ListItem = ({
  item,
  activeEntity,
  isFocused,
  setFocusedText = () => {},
  searchQuery,
  variant = 'default',
  companyCountTypes,
}: ListItemProps) => {
  if (activeEntity) {
    const indicator = item as SnakeMeta;
    return (
      <IndicatorListItem
        onFocus={setFocusedText}
        isFocused={isFocused}
        item={indicator}
        matchedEntity={activeEntity}
        logoNode={<AssetLogoContainer entity={activeEntity} size={12} />}
      />
    );
  }

  const isTheme = isThemeItem(item);

  if (isTheme) {
    return (
      <ListThemeItem
        theme={item}
        onFocus={setFocusedText}
        highlighted={searchQuery}
        isFocused={isFocused}
        companyCountTypes={companyCountTypes}
      />
    );
  }

  const entityWithIndicator = item as EntityWithIndicator;
  const data = entityWithIndicator.entity ?? item;
  const isEntity = isEntityItem(data);

  if (isEntity) {
    return (
      <ListEntityItem
        entity={data}
        isFocused={isFocused}
        onFocus={setFocusedText}
        highlighted={searchQuery}
        snakeName={entityWithIndicator.snakeMeta?.name.english}
      />
    );
  }

  const titleItem = item as TitleItem;
  return <ListTitleItem item={titleItem} variant={variant} />;
};
